import { ReactNode } from 'react';
import { NsAlert } from 'components/common/ns-alert/NsAlert';

export const testId = 'alertTestId';

type AlertProps = {
  message: ReactNode,
  title?: string
};

export const Alert = ({ message, title = 'Error' }: AlertProps) => {
  return (
    <NsAlert state="error" heading={title} testId={testId}>
      <p>{message}</p>
    </NsAlert>
  );
};
